import React, { forwardRef } from 'react';
import { Textarea, TextAreaProps } from '@heroui/react';
import { CharCounter } from '../CharCounter';
import styles from './CustomTextarea.module.scss';

interface CustomTextareaProps extends TextAreaProps {
  errorMessage?: string;
  showError?: boolean;
  maxChars?: number;
  minChars?: number;
}

export const CustomTextarea = forwardRef<HTMLTextAreaElement, CustomTextareaProps>(
  (props, ref) => {
    const { errorMessage, showError = false, maxChars, minChars, ...otherProps } = props;
    const isInvalid = !!errorMessage;

    const classnamesTextarea = {
      label: [styles.label, isInvalid ? 'error' : ''],
      inputWrapper: [styles.textareaWrapper, isInvalid ? 'error' : ''],
      input: styles.input,
      errorMessage: isInvalid ? 'error' : '',
    };

    return (
      <div className="flex flex-col gap-y-1">
        <Textarea
          ref={ref}
          classNames={classnamesTextarea}
          {...otherProps}
          variant="bordered"
          radius="sm"
          isInvalid={isInvalid}
          errorMessage={showError ? errorMessage : ''}
        />
        {maxChars !== undefined && (
          <CharCounter value={otherProps.value} max={maxChars} min={minChars} />
        )}
      </div>
    );
  },
);

CustomTextarea.displayName = 'CustomTextarea';
